import React, { useCallback, useState, useEffect } from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { MainLayout } from '../../components/layout/mainLayout';
import { EuiSpacer, EuiTab, EuiTabs } from '@elastic/eui';
import CreateOutletScreen from './Tabs/CreateOutletScreen';
import ListOutletsScreen from './Tabs/ListOutletsScreen';

const SubscriptionPage = () => {
    const { subscriptionId } = useParams();
    const location = useLocation();
    const history = useHistory();

    // Get tab from URL query params
    const queryParams = new URLSearchParams(location.search);
    const tabFromUrl = queryParams.get('tab') || (subscriptionId ? 'create_outlet' : 'list_outlet');

    const [currentTab, setCurrentTab] = useState(tabFromUrl);

    useEffect(() => {
        const tab = queryParams.get('tab');
        if (tab) {
            setCurrentTab(tab);
        } else if (subscriptionId) {
            setCurrentTab('create_outlet');
        }
    }, [subscriptionId, location.search]);

    const handleTabSelection = useCallback(
        (label) => {
            // Update URL with tab parameter
            history.push(`/subscription?tab=${label}`);
            setCurrentTab(label);
        },
        [history]
    );
    return (
        <MainLayout title='Subscription Page'>
            <EuiTabs>
                <EuiTab isSelected={currentTab === 'list_outlet'} onClick={() => handleTabSelection('list_outlet')}>
                    List Outlet's
                </EuiTab>
                <EuiTab isSelected={currentTab === 'create_outlet'} onClick={() => handleTabSelection('create_outlet')}>
                    Create Outlet
                </EuiTab>
            </EuiTabs>

            <EuiSpacer />

            {currentTab === 'create_outlet' ? (
                <CreateOutletScreen subscriptionId={subscriptionId} />
            ) : (
                <ListOutletsScreen />
            )}
        </MainLayout>
    );
};

export default SubscriptionPage;
